import { createAction } from '@reduxjs/toolkit';

import type {
  UpdateDisclaimerMessagePayload,
  UpdateGreetingPayload,
  UpdatePersonalityPayload,
  UpdateRolePayload,
  UpdateRulesPayload,
} from '@polyai/stream/commands/handlers/agent-settings';
import type { UpdateLanguageBehaviorPayload } from '@polyai/stream/commands/handlers/agent-settings/update-language-behavior/schema';

const PREFIX = 'agentSettings';

const updateDisclaimerMessage = createAction<UpdateDisclaimerMessagePayload>(
  `${PREFIX}/updateDisclaimerMessage`,
);

const updateGreeting = createAction<UpdateGreetingPayload>(
  `${PREFIX}/updateGreeting`,
);

const updatePersonality = createAction<UpdatePersonalityPayload>(
  `${PREFIX}/updatePersonality`,
);

const updateRole = createAction<UpdateRolePayload>(`${PREFIX}/updateRole`);

const updateRules = createAction<UpdateRulesPayload>(`${PREFIX}/updateRules`);

const updateLanguageBehavior = createAction<UpdateLanguageBehaviorPayload>(
  `${PREFIX}/updateLanguageBehavior`,
);

export {
  updateDisclaimerMessage,
  updateGreeting,
  updateLanguageBehavior,
  updatePersonality,
  updateRole,
  updateRules,
};
